// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Shipping20FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Shipping20Filled: FC<Shipping20FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <path d="m.5 11.167.375-1.5H5l-.375 1.5H.5ZM5.75 16.5a2.411 2.411 0 0 1-1.77-.73A2.41 2.41 0 0 1 3.25 14H1.5l.625-1.833h3.27l.71-2.834h1.54l.876-3.5H4.375L4.667 5a1.49 1.49 0 0 1 1.416-1H15.5l-.75 3h1.75l2.5 3.5-1 3.5h-1c0 .694-.243 1.285-.73 1.77a2.411 2.411 0 0 1-1.77.73 2.411 2.411 0 0 1-1.77-.73A2.411 2.411 0 0 1 12 14H8.25a2.41 2.41 0 0 1-.73 1.77 2.411 2.411 0 0 1-1.77.73ZM2 8.333l.375-1.5H7.25l-.375 1.5H2ZM5.75 15c.283 0 .52-.096.713-.287A.968.968 0 0 0 6.75 14a.968.968 0 0 0-.287-.713A.967.967 0 0 0 5.75 13a.967.967 0 0 0-.713.287.968.968 0 0 0-.287.713c0 .283.096.52.287.713.192.191.43.287.713.287Zm8.75 0c.283 0 .52-.096.713-.287A.968.968 0 0 0 15.5 14a.968.968 0 0 0-.287-.713A.968.968 0 0 0 14.5 13a.968.968 0 0 0-.713.287.968.968 0 0 0-.287.713c0 .283.096.52.287.713.192.191.43.287.713.287Zm-.75-4h3.542l.062-.23L15.73 8.5h-1.354L13.75 11Z" />
        </svg>
    );
};

export default Shipping20Filled;
